var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { FocusRing, Hyperlink } from '@ingka/common-styles-webc';
import { Status as SkapaStatus } from '@ingka/status-webc/passive.js';
import AssemblyServicesStatusButtonStyle from './AssemblyServicesStatusButtonStyle.js';
/**
 * @event statusButtonClick User clicks on the assembly services status button.
 */
export default class AssemblyServicesStatusButton extends KompisElement {
    constructor() {
        super(...arguments);
        // Assembly services data, containing if assembly services are available or not.
        this.assemblyServicesData = null;
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // Submitted and validated ZIP code.
        this.zipCode = null;
    }
    async connectedCallback() {
        this.customElements.define('skapa-status', SkapaStatus);
        super.connectedCallback();
    }
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html `
			<style>
				${Hyperlink.CSS + FocusRing.CSS}
				${AssemblyServicesStatusButtonStyle.getStyle({ theme: this.theme })}
			</style>

			${this.getContent()}
		`;
    }
    hasTranslations() {
        return !!this.localizedInformation || !!this.translations;
    }
    getTranslations() {
        const translations = this.translations
            ? this.translations
            : this.localizedInformation?.translations;
        return translations;
    }
    getContent() {
        const position = 'leading';
        const color = this.getStatusIndicatorColor();
        // Status needs to be the same element between states for focus to be put back when setting or forgetting a zip code.
        return html `<skapa-status
			colour="${color}"
			class="${color ? '' : 'status-hidden'}"
			position="${position}"
			><span>${this.getLabel()}</span></skapa-status
		>`;
    }
    getStatusIndicatorColor() {
        if (!this.zipCode || !this.assemblyServicesData) {
            return null;
        }
        return this.assemblyServicesData?.valid ? 'green' : 'red';
    }
    getLabel() {
        return html `${this.getAvailabilityText()}${this.getButton()}`;
    }
    getAvailabilityText() {
        const { assemblyServicesStatusAvailableZip, assemblyServicesStatusUnavailableZip } = this.getTranslations();
        if (!this.zipCode || !this.assemblyServicesData) {
            return null;
        }
        if (this.assemblyServicesData.valid) {
            return assemblyServicesStatusAvailableZip.replace('{{zip_code}}', '');
        }
        return assemblyServicesStatusUnavailableZip.replace('{{zip_code}}', '');
    }
    getButton() {
        return html `<button
			class="buttonAsLinkResets ${Hyperlink.classnames()} buttonAsLinkStyling"
			@click="${() => {
            this.dispatchEvent(new CustomEvent('statusButtonClick', { bubbles: true }));
        }}"
		>
			<span
				>${this.zipCode && this.assemblyServicesData
            ? this.zipCode
            : this.getTranslations().assemblyServicesStatusDefault}</span
			>
		</button>`;
    }
}
__decorate([
    property({ type: Object, required: true })
], AssemblyServicesStatusButton.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], AssemblyServicesStatusButton.prototype, "assemblyServicesData", void 0);
__decorate([
    property({ type: Object })
], AssemblyServicesStatusButton.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], AssemblyServicesStatusButton.prototype, "translations", void 0);
__decorate([
    property({ type: String })
], AssemblyServicesStatusButton.prototype, "zipCode", void 0);
//# sourceMappingURL=AssemblyServicesStatusButton.js.map